import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

import * as cardStyles from './Card.styles';

export interface CardProps {
  children?: ReactNode;
  title: string;
}

function Card({ children, title }: CardProps) {
  const { classes: cardClasses } = cardStyles.orderDetailsCardStyle();

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Box flexGrow="1" className={cardClasses.card}>
        {children}
      </Box>
    </Box>
  );
}

export default Card;
